/* Carrusel que corre solo y que TAMBIEN se puede arrastrar.
   ----------------------------------------------------------------------
   Lo usan la hilera de videos y la de referencias (10-sep-2026).

   Por que no es una animacion de CSS: la marquesina anterior era @keyframes
   sobre un translate. Se ve bien pero es intocable — si el visitante quiere
   regresar a ver una tarjeta que ya paso, no puede. Aqui el movimiento es
   scrollLeft, asi que el dedo y el cursor lo mueven igual que cualquier lista,
   y al soltar sigue corriendo solo.

   La lista se pinta TRES veces. El script arranca parado en el juego de en
   medio y, al salirse por cualquiera de los dos lados, salta un juego completo.
   El salto cae en pixeles identicos, asi que no se ve. Arrancar en medio es lo
   que permite que una hilera corra al reves sin quedarse sin pista.

   DIRECCION: `data-dir="-1"` en el contenedor la hace correr al otro lado.
   En la portada las dos hileras van encontradas (videos hacia un lado,
   referencias hacia el otro): da mejor ritmo que las dos en paralelo.

   ===== TRES ERRORES QUE YA SE COMETIERON AQUI. NO REPETIRLOS. =====

   1) NO HACER `fila.scrollLeft += algo` CON DECIMALES.
      A 26 px/s son 0.43 px por cuadro. El navegador REDONDEA scrollLeft al
      leerlo, asi que 0.43 se pierde en el redondeo y el carrusel **se queda
      completamente quieto**. Fue exactamente lo que paso el 10-sep-2026: el
      dueno reporto "no se mueven". Medido: 60 cuadros con `+=` dieron 0 px;
      con la variable `pos` dieron 26 px. Por eso la posicion se lleva aparte,
      en decimal de verdad, y a scrollLeft solo se le ASIGNA.

   2) NO MEDIR UNA PASADA COMO `pista.scrollWidth / 3`.
      Con padding lateral en la pista el padding entra al scrollWidth pero no
      se repite tres veces: medido, 7px de error en referencias y 6px en
      videos, o sea un brinco visible cada vuelta. Se mide con offsetLeft.

   3) NADA DE scroll-snap en el contenedor: pelea con el avance de cada cuadro
      y produce tironeo.

   Y al medir esto en un panel de navegador OCULTO, requestAnimationFrame no
   corre y el scroll se queda en 0. Eso es artefacto del panel, no un bug:
   comprobarlo con document.hidden antes de diagnosticar. */
(function () {
  function init(fila, opts) {
    if (!fila || fila.dataset.xcListo) return;   // el archivo se incluye en dos
    fila.dataset.xcListo = '1';                  // secciones; que no arranque doble
    opts = opts || {};
    var vel = (opts.vel || 26) * (opts.dir || 1);   // px por segundo, con signo
    var pista = fila.firstElementChild;
    if (!pista) return;
    var quieto = matchMedia('(prefers-reduced-motion: reduce)');

    var uno = 0;                            // ancho exacto de UNA pasada
    function medir() {
      var hijos = pista.children;
      var porPasada = Math.floor(hijos.length / 3);
      if (porPasada > 0 && hijos[porPasada]) {
        uno = hijos[porPasada].offsetLeft - hijos[0].offsetLeft;
      } else {
        uno = pista.scrollWidth / 3;          // respaldo
      }
    }
    medir();
    if (window.ResizeObserver) new ResizeObserver(medir).observe(pista);
    else window.addEventListener('resize', medir);

    var pausado = false, arrastrando = false, ultimo = 0, idPuntero = null;
    var pos = 0;                            // la posicion de verdad, con decimales

    function envolver() {
      if (uno <= 0) return false;
      if (pos >= uno * 2) { pos -= uno; return true; }
      if (pos < uno * 0.5) { pos += uno; return true; }
      return false;
    }

    function paso(t) {
      if (!ultimo) ultimo = t;
      var dt = (t - ultimo) / 1000;
      ultimo = t;

      /* Si el visitante lo movio (arrastre, dedo, rueda), su posicion manda */
      if (Math.abs(fila.scrollLeft - pos) > 3) pos = fila.scrollLeft;

      /* dt grande = la pestana estuvo en segundo plano. Se descarta para que
         al volver no pegue un brinco de varios segundos de golpe. */
      var corre = !pausado && !arrastrando && !quieto.matches && dt > 0 && dt < 0.25 && uno > 0;
      if (corre) pos += vel * dt;
      var salto = envolver();
      if (corre || salto) fila.scrollLeft = pos;

      requestAnimationFrame(paso);
    }

    /* Las fotos y los posters cambian el ancho al cargar: se vuelve a medir
       cuando ya esta todo pintado, si no la pasada sale corta. */
    function arrancar() {
      medir();
      if (uno > 0) { pos = uno; fila.scrollLeft = pos; }   // juego de en medio
      requestAnimationFrame(paso);
    }
    if (document.readyState === 'complete') requestAnimationFrame(arrancar);
    else window.addEventListener('load', function () { requestAnimationFrame(arrancar); });

    /* Con el cursor encima se detiene: si algo llamo la atencion, que no se
       vaya solo. En pantalla tactil se dispara al tocar y se suelta al
       levantar el dedo, que es justo lo que se quiere. */
    fila.addEventListener('pointerenter', function () { pausado = true; });
    fila.addEventListener('pointerleave', function () { pausado = false; });

    /* Arrastre con el raton. El dedo ya arrastra solo (overflow-x:auto), asi
       que en tactil no se toca nada: meter mano ahi mata el impulso nativo. */
    var x0 = 0, s0 = 0, movido = 0;
    fila.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'touch') return;
      arrastrando = true; idPuntero = e.pointerId; movido = 0;
      x0 = e.clientX; s0 = fila.scrollLeft;
      try { fila.setPointerCapture(idPuntero); } catch (err) {}
      fila.classList.add('xc-agarrando');
    });
    fila.addEventListener('pointermove', function (e) {
      if (!arrastrando || e.pointerId !== idPuntero) return;
      e.preventDefault();
      movido = Math.abs(e.clientX - x0);
      fila.scrollLeft = s0 - (e.clientX - x0);
      pos = fila.scrollLeft;
    });
    function soltar(e) {
      if (!arrastrando || (e && e.pointerId !== idPuntero)) return;
      arrastrando = false;
      pos = fila.scrollLeft;
      try { fila.releasePointerCapture(idPuntero); } catch (err) {}
      fila.classList.remove('xc-agarrando');
    }
    fila.addEventListener('pointerup', soltar);
    fila.addEventListener('pointercancel', soltar);

    /* Arrastrar no debe abrir el enlace que quedo debajo del cursor */
    fila.addEventListener('click', function (e) {
      if (movido > 6) { e.preventDefault(); e.stopPropagation(); movido = 0; }
    }, true);
  }

  window.xcCarrusel = init;

  function arranca() {
    [].forEach.call(document.querySelectorAll('[data-xc-fila]'), function (f) {
      init(f, {
        vel: parseFloat(f.dataset.vel) || 26,
        dir: parseFloat(f.dataset.dir) || 1
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', arranca);
  else arranca();
})();
